import React, { ChangeEvent, useState } from 'react';
import Loader from '../../../components/Common/Loader';
import BackButton from '../../../components/Common/BackButton';

interface ClassroomAddNewItemsProps {
  close?: () => void;
  back?: () => void;
  submit: (name: string) => void;
  loader?: boolean;
  isOnboarding?: boolean;
  inputAsButton?: boolean;
  isCentered?: boolean;
  isInline?: boolean;
}

const ClassroomAddNewItems: React.FC<ClassroomAddNewItemsProps> = ({
  close,
  back,
  submit,
  loader,
  isOnboarding,
  inputAsButton,
  isCentered,
  isInline,
}: ClassroomAddNewItemsProps) => {
  const [currentName, setCurrentName] = useState('');

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCurrentName(value);
  };

  return (
    <div className={`flex flex-col text-black font-sofiaSans mt-4 ${isCentered ? 'items-center' : 'items-start'}`}>
      <label htmlFor="emails" className="block mb-2 font-bold text-black">
        Name
      </label>

      <div className="w-full border border-gray-300 rounded p-2 mb-4">
        <div className={`w-full flex flex-wrap gap-1`}>
          <input
            type="names"
            id="names"
            name="names"
            placeholder="Name"
            className="flex-1 min-w-[150px] w-full outline-none"
            value={currentName}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className={`flex w-full ${isOnboarding ? 'justify-between' : 'justify-end'} gap-2 mt-1`}>
        {isOnboarding && back && <BackButton onClick={back}></BackButton>}
        {!isOnboarding && (
          <button
            onClick={close}
            className="bg-transparent hover:bg-[#000000] hover:bg-opacity-20 text-black font-semibold py-2 px-4 rounded-full focus:outline-none focus:ring-1 w-auto flex items-center"
          >
            Cancel
          </button>
        )}
        <button
          className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center ${
            currentName?.length ? '' : 'opacity-50 cursor-not-allowed'
          }`}
          onClick={() => submit(currentName)}
          disabled={!currentName?.length}
        >
          Create
          <Loader loader={loader} dimentions="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};

export default ClassroomAddNewItems;
